import { soundClipsEn } from './en'

export const soundClipsEnCa = {
  ...soundClipsEn,
} as const
